// ai/feedback/download-feedback.ts
//
// Storydoc staff's read-back of the votes recorded by ./record-feedback: the
// newest 2,000, as a CSV sheet — date, vote, reason, request, reply, action,
// route, skill, user, org and deck. The export needs the signed-in session (the
// backend checks for staff), so it is fetched here and saved as a file rather
// than opened as a link.

import { store } from "@store/store";
import { aiApi } from "@api/ai";

const EXPORT_LIMIT = 2000;

type Dispatch = (action: unknown) => { unwrap: () => Promise<unknown> };
type Save = (csv: string, filename: string) => void;

const saveAsFile: Save = (csv, filename) => {
  const url = URL.createObjectURL(
    new Blob([csv], { type: "text/csv;charset=utf-8" }),
  );
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

/** Downloads the sheet; resolves false when it could not be fetched. */
export const createFeedbackDownload =
  (
    dispatch: Dispatch = (action) =>
      store.dispatch(action as never) as unknown as ReturnType<Dispatch>,
    api: typeof aiApi = aiApi,
    save: Save = saveAsFile,
  ) =>
  async (now: Date = new Date()): Promise<boolean> => {
    try {
      const csv = await dispatch(
        api.endpoints.getAgentFeedbackCsv.initiate(
          { limit: EXPORT_LIMIT },
          { subscribe: false, forceRefetch: true },
        ),
      ).unwrap();
      if (typeof csv !== "string") return false;
      save(csv, `agent-feedback-${now.toISOString().slice(0, 10)}.csv`);
      return true;
    } catch {
      return false;
    }
  };

export const downloadAgentFeedbackCsv = createFeedbackDownload();
